module.exports = __webpack_public_path__ + "img/logo-white.317c2b38.png";